
<template>
  <div>
    
    <b-row>
      <b-col cols="7" style="background: white; padding: 20px; margin: 20px">
        <b-col cols="4"
          ><h3>Resim Seç</h3>
          <input type="file" @change="onFileChange"
        /></b-col>
      </b-col>
      <b-col cols="3">
        <b-row>
          <!--
          <vs-card style="margin: 10px">
            <div slot="header">
              <h3>Resim Update</h3>
            </div>
            <div>
              <vs-button
                @click="resimUpdate()"
                style="border-radius: 5px"
                color="success"
                type="gradient"
                >Resim Güncelle</vs-button
              >
            </div>
          </vs-card>-->
        </b-row>
      </b-col>

    </b-row>

    <vs-table :data="stokResimListesi">
      <template slot="thead">
        <vs-th></vs-th>
        <vs-th>Stok Kodu</vs-th>
        <vs-th>Barkod</vs-th>
        <vs-th>Resim Adı</vs-th>
        <vs-th>Sil</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td
            ><img
              style="width: 50px"
              v-bind:src="
                imageUrl.replace('sistem.asmx?WSDL', 'uploads/') +
                  data[indextr].resimAdi
              "
              alt=""
          /></vs-td>
          <vs-td>
            {{ data[indextr].stokKodu }}
          </vs-td>
          <vs-td>
            {{ data[indextr].barkod }}
          </vs-td>
          <vs-td>
            {{ data[indextr].resimAdi }}
          </vs-td>
          <vs-td>
            <div>
              <b-icon
              icon="trash-fill"
              type="border"
              size="large"
              variant="danger"
              v-b-tooltip.hover.bottom="'Sil'"
              @click="showDeleteConfirmation"
            />
            <vs-prompt
              color="danger"
              title=""
              acceptText="Evet"
              cancelText="Vazgeç"
              @accept="resimSil(data[indextr].id)"
              @cancel="cancelDelete"
              :active.sync="deleteConfirmationVisible" 
            >
              <div class="con-exemple-prompt">
                <span>Silmek istediğinize emin misiniz?</span>
              </div>
            </vs-prompt>
            </div>
            
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import state from "../../store/state";
import Store from "../../store/store";
export default {
  
  data() {
    return {
      imageUrl: state.sistemAddress,
      stokResimListesi: [],
      deleteConfirmationVisible: false  
    };
  },
  props: {
    pictureData: {
      default: () => {},
      required: true
    }
  },
  methods: {
    cancelDelete() {
      this.deleteConfirmationVisible = false;
    },
    async showDeleteConfirmation() {
      
      // Silme onay alertini göster
      this.deleteConfirmationVisible = true;
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      //console.log(reader)
      reader.onload = e => {
        vm.image = e.target.result;
        vm.imageBase64 = e.target.result;
        console.log(vm.image);

        vm.upload(e.target.result, file.name);
      };
      reader.readAsDataURL(file);
    },
    upload(f, fileName) {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "upload");
      console.log( vm.pictureData)
      const args = {
        f: f,
        stokKodu: vm.pictureData.stokKodu,
        barkod: vm.pictureData.Barkod,
        fileName: fileName
      };
      soap.createClient(url, function(err, client) {
        client.uploadFileProduct(args, function(err, result) {
          console.log(result);
          if (result.uploadFileProductResult == "Ok") {
            vm.resimListesi();
            vs.notify({
              title: "Başarılı",
              text: "Resim ekleme başarılı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center"
            });
          } else {
            vs.notify({
              title: "Hata",
              text: "Resim eklenirken hata oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
          //vm.veriler=JSON.parse(result.iadeKabulListesineEkleResult)
          //vm.barkodOku(orderNumber.trim())
        });
      });
    },
    resimUpdate() {
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId
      };
      soap.createClient(url, function(err, client) {
        client.resimUpdate(args, function(err, result) {
          return result.resimUpdateResult;
        });
      });
    },
    resimSil(resimId) {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = { token: Store.state.tokenId, resimId: resimId };
      soap.createClient(url, function(err, client) {
        client.stokResimSil(args, function(err, result) {
          if (result.stokResimEkleResult == "-1") {
            Store.dispatch("logout");
          }

          vm.resimListesi();
          vm.imageBase64 = "";
        });
      });
    },

    resimListesi() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        stokKodu: vm.pictureData.stokKodu,
        barkod: vm.pictureData.Barkod
      };
      console.log(args)
      soap.createClient(url, function(err, client) {
        client.stokResimListesi(args, function(err, result) {
          if (result.stokResimListesiResult == "-1") {
            Store.dispatch("logout");
          }
          vm.veriler = JSON.parse(result.stokResimListesiResult);
          vm.stokResimListesi = vm.veriler;
          console.log(vm.stokResimListesi);
        });
      });
    }
  },
  created() {
    this.resimListesi();
  }
};
</script>
<style>
.con-vs-popup {
  z-index: 999999;
}
</style>